import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-713f3b51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "switchOptionWrapper" }
const _hoisted_4 = { class: "switchText" }
const _hoisted_5 = { class: "switchOptionWrapper" }
const _hoisted_6 = { class: "switchText" }
const _hoisted_7 = { class: "switchOptionWrapper" }
const _hoisted_8 = { class: "switchText" }
const _hoisted_9 = { class: "switchOptionWrapper" }
const _hoisted_10 = { class: "switchText" }
const _hoisted_11 = { class: "mt-7" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "contentBox block w-full" }

import {useGlobalStore} from '@/stores/GlobalStore'
import {ref} from "vue";
import {$t} from "@/utilities/i18n/config";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import Error from "@/components/Error.vue";
import TextOrSpinner from "@/components/TextOrSpinner.vue";
import UserService from "@/utilities/services/entities/UserService";
import {useI18n} from "vue-i18n";
import AuthService from "@/utilities/services/AuthService";
import router from "@/router";
import User from "@/models/entities/User";



export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const {t} = useI18n();
const globalStore = useGlobalStore();
const userService = new UserService();

const loadingConfirm = ref<boolean>(false);

const logoutUser = async () =>{
  const oAuthService = AuthService.getDefaultInstance();

  await oAuthService.logoutSilent();
  globalStore.user = null;
  await router.push("/logout");
};

const updateConfig = async () =>{
  loadingConfirm.value = true;
  const resp = await userService.updateUserConfig(globalStore.user as User, ErrorLocationType.table)
  loadingConfirm.value = false;
  if(!resp) return;

  globalStore.showSuccess(t("general.saved"))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)('account.myAccount')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Error, {
        errorLoc: _unref(ErrorLocationType).table
      }, null, 8, ["errorLoc"]),
      _createElementVNode("h3", null, _toDisplayString(_unref($t)("account.pushMessages.title")), 1),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "switch",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(globalStore).user!.notifications.downloadNotifications) = $event))
        }, null, 512), [
          [_vModelCheckbox, _unref(globalStore).user!.notifications.downloadNotifications]
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref($t)('account.pushMessages.download')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "switch",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(globalStore).user!.notifications.uploadNotifications) = $event))
        }, null, 512), [
          [_vModelCheckbox, _unref(globalStore).user!.notifications.uploadNotifications]
        ]),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref($t)('account.pushMessages.uploadTicket')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "switch",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(globalStore).user!.notifications.deleteNotifications) = $event))
        }, null, 512), [
          [_vModelCheckbox, _unref(globalStore).user!.notifications.deleteNotifications]
        ]),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref($t)('account.pushMessages.fileDeletion')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "switch",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(globalStore).user!.notifications.mailSendNotifications) = $event))
        }, null, 512), [
          [_vModelCheckbox, _unref(globalStore).user!.notifications.mailSendNotifications]
        ]),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref($t)('account.pushMessages.mailSend')), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          disabled: loadingConfirm.value,
          class: "primary ml-auto",
          onClick: updateConfig
        }, [
          _createVNode(TextOrSpinner, {
            text: _unref($t)('general.save'),
            spin: loadingConfirm.value
          }, null, 8, ["text", "spin"])
        ], 8, _hoisted_12)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, _toDisplayString(_unref($t)("account.logoutTitle")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn secondary",
            onClick: logoutUser
          }, _toDisplayString(_unref($t)('account.logoutButton')), 1)
        ])
      ])
    ])
  ], 64))
}
}

})